export const APP_GTM_KEY = import.meta.env.VITE_APP_GTM_KEY;
